module.exports = __webpack_public_path__ + "media/src/images/icons/cross-a98b6cb8516068dc0069f8db68ba0662.svg";